import { ignoreErrors as axiosNeuron } from "api/axios";
import endpoints from "api/endpoints";
import { IPlacementList } from "types/placement";

interface IModelsParams {
  modelId: number;
}

export default async function getModelHistogram({ modelId }: IModelsParams) {
  const url = endpoints.machines.modelHistogram;

  try {
    const { data } = await axiosNeuron.get(`${url}?model_id=${modelId}`);

    const placementIds =
      data &&
      data.results.columns.map((item: string) =>
        item.replace("placement_", "")
      );

    const placements = placementIds.length
      ? await axiosNeuron.get(endpoints.placements.default, {
          params: {
            id: placementIds.map((placement: any) => Number(placement)),
          },
        })
      : null;

    const newData = placements
      ? placements.data.results.map((placement: any) => ({
          id: placement.id,
          customName: placement.custom_name,
          placementTypeName: placement.placement_type_name,
        }))
      : [];

    return {
      ...data,
      results: {
        ...data.results,
        placements: newData,
      },
    };
  } catch (error) {
    if (error !== undefined) {
      throw error;
    }
  }
}
